<template>
  <div>
    <div class="head">
      <img src="../../assets/damai.png" alt="" class="logoImg">
      <div class="button-wrapper">
        <Button type="primary" icon="edit" @click="openSimple = true;" v-if="authList.indexOf('003003') !== -1">修改密码</Button>
        <Button type="error" icon="power" @click="loginOut">退出登录</Button>
      </div>
    </div>

    <Modal
      v-model="openSimple"
      title="修改密码"
      @on-ok="sureModify"
      @on-cancel="cancelModify">
      <div style="margin: 10px;text-align: center;"><span style="display: inline-block;width: 60px;text-align: left;">用户名</span><Input v-model="pwdForm.userName" disabled style="width: 300px" :maxlength=32 /></div>
      <div style="margin: 10px;text-align: center;"><b style="color: red;">*</b><span style="display: inline-block;width: 60px;text-align: left;">旧密码</span><Input v-model="pwdForm.password" type="password" style="width: 300px" :maxlength=32 /></div>
      <div style="margin: 10px;text-align: center;"><b style="color: red;">*</b><span style="display: inline-block;width: 60px;text-align: left;">新密码</span><Input v-model="pwdForm.newPassword" type="password" style="width: 300px" :maxlength=32 /></div>
    </Modal>
  </div>
</template>

<script>
import {httpUrl} from '../../api'
import {nSuccess, nError} from '../../util/notice'
import {errorHandler} from '../../util/errorHandler'
import {getAuthStr} from '../../util/bus'
import md5 from 'js-md5'

export default {
  name: 'top-ope',
  data () {
    return {
      authList: '',
      openSimple: false,
      pwdForm: {
        userName: '',
        password: '',
        newPassword: ''
      }
    }
  },
  created () {
    this.authList = getAuthStr()
    this.pwdForm.userName = window.sessionStorage.getItem('theDevUserName')
  },
  methods: {
    loginOut () {
      this.$axios.post(`${httpUrl.url}/manage/logout`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            this.$router.push({
              path: '/login'
            })
          }
        })
        .catch(() => {
          this.$Message.error('获取数据失败')
        })
    },
    sureModify () {
      if (!this.pwdForm.password) {
        nError('旧密码不能为空')
        return false
      }
      if (!this.pwdForm.newPassword) {
        nError('新密码不能为空')
        return false
      }
      let userName = this.pwdForm.userName.toLowerCase()
      let pw = this.pwdForm.password + userName
      let once = md5(pw) + userName
      let pwd
      for (let i = 0; i < 9; i++) {
        pwd = md5(once)
        once = pwd + userName
      }
      let npw = this.pwdForm.newPassword + userName
      let nonce = md5(npw) + userName
      let npwd
      for (let i = 0; i < 9; i++) {
        npwd = md5(nonce)
        nonce = npwd + userName
      }
      this.$axios.post(`${httpUrl.url}/manage/user/updatePassWord`, {
        'userName': this.pwdForm.userName,
        'password': pwd,
        'newPassword': npwd
      })
        .then(res => {
          if (res.data.retCode === 1) {
            this.openSimple = false
            this.pwdForm.password = ''
            this.pwdForm.newPassword = ''
            nSuccess('修改成功')
          }
        })
        .catch(errorHandler('修改失败'))
    },
    cancelModify () {
      this.pwdForm.password = ''
      this.pwdForm.newPassword = ''
      this.openSimple = false
    }
  }
}
</script>

<style scoped>
  .head {
    min-width: 1550px;
    display: flex;
    justify-content: space-between;
    background-color: #62c8fd;
  }

  .logoImg {
    width: 150px;
    height: 44px;
    margin: 5px 10px 5px 20px;
  }

  .button-wrapper {
    padding: 10px 15px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/views/top-ope/top-ope.vue